import css, { SystemStyleObject } from '@styled-system/css';

import { StyleFn } from './types';

export interface SxProp {
  sx?: SystemStyleObject;
}

const sx: StyleFn<SxProp> = ({ sx }) => css(sx);

export default sx;
